import './ProductExplanation.scss';

function ProductExplanation() {
  return (
    <div className="product-explanation">ProductExplanation Component</div>
  );
}

export { ProductExplanation };
